import React from "react";
import { PillsContainer, Pill, ItemNumber } from "./styles";
import { Context } from "../../Store";
import {
  getCompletedTeamMeetingsCount,
  getRequestedMeetingsCount,
  getUpcomingTeamMeetingsCount,
} from "../../Store/ProgramMeetingCount/accessors";

// Similar to Tabs
function Pills({
  options,
  value,
  setValue,
  count,
  isWidth,
  isMeetingTab = false,
  applicationPills,
  meetings,
  isConnection,
}) {
  const { dispatch, state } = React.useContext(Context);
  const RenderComponent = (value) => {
    switch (value) {
      case "Requests":
        return getRequestedMeetingsCount(state).count;
      case "Upcoming":
        return getUpcomingTeamMeetingsCount(state).count
          ? getUpcomingTeamMeetingsCount(state).count
          : count?.upComingRequests;
      case "Past":
        return getCompletedTeamMeetingsCount(state).count
          ? getCompletedTeamMeetingsCount(state).count
          : count?.pastRequests;
      case "unfulfilled":
        return count?.unfulfilledRequests;
      case "Archived":
        return count?.archivedRequests;
      case "tasks":
        return count;
    }
  };

  // console.log("State:", state);

  // const [_, forceUpdate] = React.useReducer((x) => x + 1, 0);

  // React.useEffect(() => {
  //   // Use dispatch or a known flag in state to trigger this
  //   forceUpdate();
  // }, [dispatch, state]);

  // console.log("Options:", options);

  return (
    <PillsContainer
      isWidth={isWidth}
      isMeetingTab={isMeetingTab}
      meetings={meetings}
      isConnection={isConnection}
    >
      {options &&
        options.map((option) => (
          <Pill
            isConnection={isConnection}
            isWidth={isWidth}
            applicationPills={applicationPills}
            meetings={meetings}
            key={option?.value}
            active={value === option?.value}
            onClick={() => {
              setValue(option?.value);
            }}
          >
            {/* {option.label + " Test"} */}
            {option.label}
            {RenderComponent(option?.value) && (
              <ItemNumber>{RenderComponent(option?.value)}</ItemNumber>
            )}
          </Pill>
        ))}
    </PillsContainer>
  );
}
export default Pills;
